import React from "react";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import PagesHero from "../components/PagesHero";
import FreeOddSection from "../components/FreeOddSection";
import TestimonialSection from "../components/TestimonialSection";

function FreeBet() {
  return (
    <div>
      <Header />
      <PagesHero page={"Daily Free Odd"} />
      <FreeOddSection title={"daily"} header="Today's Free Predictions" />
      <TestimonialSection />
      <FooterSection />
    </div>
  );
}

export default FreeBet;
